export default __webpack_public_path__ + "static/media/icon_chevron_arrowhead_left.a0a2a96b.svg";